
<div class="left" *ngIf="set == 1">
<mat-icon style="text-align:right; margin-left: 95%;" class="alignedicon" (click)='close()'>close</mat-icon>
    <div class="row">
      <div class='col-12'>
        <div  style="margin-top:1%;  box-shadow:0 1px 4px rgba(0, 0, 0, .5);">
            <span *ngIf="brand && brand.length> 0">
                <h4 style="font-style: open sans ;color: #cb983f;">Brand:</h4>
                <hr>
                  <div class="form-group" style="font-size: 0.9em; color: #9b7544">
                    <div  *ngFor= "let dataa of brand">
                        <div *ngFor="let datan of dataarray | uniqFilter : 'brand_id'">
                           <div *ngIf="datan.brand_id == dataa.id">
                            <label style="font-weight:normal">
                           
                            <a (click)="setFilter(1, dataa.id)">  {{dataa.name}} ({{brandCount(dataa.id)}}) </a>
                             </label>
                            </div>
                           </div>
                          </div>
                       </div>
                 </span>
                 <span *ngIf="flavour">
                    <h4 style="font-style: open sans ;color: #cb983f">Flavour:</h4>
                     <hr>
                     <div class="form-group" style="font-size: 0.9em; color: #9b7544">
                      <div  *ngFor= "let dataa of flavour">
                        <div *ngFor="let datan of dataarray | uniqFilter : 'flavour_id'">
                          <div *ngIf="datan.flavour_id == dataa.id">
                      <label style="font-weight:normal">
                      
                     <a (click)="setFilter(2,dataa.id)">   {{dataa.name}} </a>
                      </label>
                    </div>
                  </div>
                      </div>
                     </div>
                  </span>
                  <span *ngIf="lifestage">
                      <h4 style="font-style: open sans ;color: #cb983f">Lifestage:</h4>

                     <hr>
                     <div class="form-group" style="font-size: 0.9em; color: #9b7544">

                      <div  *ngFor= "let dataa of lifestage">
                        <div *ngFor="let datan of dataarray | uniqFilter : 'lifestage_id'">
                          <div *ngIf="datan.lifestage_id == dataa.id">

                      <label style="font-weight:normal">
                  
                       <a (click)="setFilter(3, dataa.id)">  {{dataa.name}} ({{lifestageCount(dataa.id)}}) </a>
                      </label>
                    </div>
                  </div>
                      </div>
                     </div>
                   </span>

                   <div class="row">
                 
                      <div class="col-12 text-center">
                          <button class="btn btn-outline-danger btn-sm" mat-dialog-close>cancel</button>
                        </div>
                    </div>



        </div>
      </div>
    </div>

  </div>


  <div class="left" *ngIf="set == 2">
      <mat-icon style="text-align:right; margin-left: 95%;" class="alignedicon" (click)='close()'>close</mat-icon>
      <div class="row">
        <div class='col-12'>
          <div class="card" style="margin-top:1%; padding:4px; box-shadow:0 1px 4px rgba(0, 0, 0, .5);">
              <span *ngIf="brand && brand.length > 0  && category !== 'brand'">
                  <h4 style="font-style: open sans ;color: #cb983f">Brand:</h4>
                  <hr>
                    <div class="form-group" style="font-size: 0.9em; color: #9b7544">
                    <div *ngIf="searchid === undefined">
                        <div  *ngFor= "let dataa of brand">
                            <div *ngFor="let datan of dataarray | uniqFilter : 'brand_id'">
                              <div *ngIf="datan.brand_id == dataa.id">
                                <label style="font-weight:normal">
                           
                            <a (click)="setFilter(1, dataa.id)">  {{dataa.name}} ({{brandCount(dataa.id)}}) </a>
                          </label>
                      </div>
                  </div>
                </div>
              </div>
              <div *ngIf="searchid && dynamicbrandarray.length>0">
                  <div  *ngFor= "let dataa of brand |  dynamicbrand: dynamicbrandarray">
                      <label style="font-weight:normal">
                      
                          <a (click)="setFilter(1, dataa.id)">  {{dataa.name}}({{tempbrandCount(dataa.id)}}) </a>
                     </label>

                  </div>
              </div>
            </div>
                   </span>
                   <span *ngIf="flavour">
                      <h4 style="font-style: open sans ;color: #cb983f" *ngIf="!searchid"
                      >Flavour:</h4>
                      <h4 style="font-style: open sans ;color: #cb983f" *ngIf="searchid && dynamicflavourarray.length > 0 "
                      >Flavour:</h4>
                       <hr>
                     <div class="form-group" style="font-size: 0.9em; color: #9b7544">
                        <div  *ngFor= "let dataa of flavour | dynamicflavour: dynamicflavourarray">
                          <div *ngFor="let datan of dataarray | uniqFilter : 'flavour_id'">
                            <div *ngIf="datan.flavour_id == dataa.id">
                        <label *ngIf="searchid && tempsearchdata.length > 0" style="font-weight:normal">
                         
                            <a (click)="setFilter(2, dataa.id)">   {{dataa.name}} ({{tempflavourCount(dataa.id)}}) </a>
                      
                            </label>
                        <label *ngIf="!searchid" style="font-weight:normal">
    
                            <a (click)="setFilter(2, dataa.id)">     {{dataa.name}} ({{flavourCount(dataa.id)}}) </a>
                           </label>
                      </div>
                    </div>
                        </div>
                       </div>
                    </span>
                    <span *ngIf="lifestage && category !== 'lifestage'">
                        <h4 style="font-style: open sans ;color: #cb983f">Lifestage:</h4>

                       <hr>
                     <div class="form-group" style="font-size: 0.9em; color: #9b7544">

                        <div  *ngFor= "let dataa of lifestage | dynamiclifestage : dynamiclifearray">
                          <div *ngFor="let datan of dataarray | uniqFilter : 'lifestage_id'">
                            <div *ngIf="datan.lifestage_id == dataa.id">

                        <label *ngIf="searchid && tempsearchdata.length > 0" style="font-weight:normal">
                            <a (click)="setFilter(3, dataa.id)">
                          {{dataa.name}}({{templifestageCount(dataa.id)}}) </a>
                        </label>
                        <label *ngIf="!searchid" style="font-weight:normal">
                          
                            <a (click)="setFilter(3, dataa.id)">   {{dataa.name}}({{lifestageCount(dataa.id)}}) </a>
                           </label>
                      </div>
                    </div>
                        </div>
                       </div>
                     </span>
                     <div class="row">
                        
                             <div class="col-12 text-center">
                                 <button class="btn btn-outline-danger btn-sm" mat-dialog-close>cancel</button>
                               </div>
                           </div>


          </div>
        </div>
      </div>

    </div>




